/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {SnackbarContent, useSnackbar} from 'notistack';
import {NotificationCard, NotificationCardType} from '@ion/dls/src/notifications/NotificationCard';
import ViewEventCta from './ViewEventCta';

const useStyles = makeStyles((theme) => ({
  root : {
    minHeight                      : '136px',
    width                          : '414px',
    maxWidth                       : '414px',
    [theme.breakpoints.down('sm')] : {
      maxWidth : 'none',
      width    : '100%'
    }
  }
}));

export const NotificationAlert = React.forwardRef(
  (
    {
      id,
      toastId,
      type,
      text,
      subText,
      read,
      timeStamp,
      notification,
      isUrgent,
      onMoreClick,
      onLessClick,
      onReviewClick,
      onDoubleClick,
      moreInfoLoading,
      showMoreInfo
    }: NotificationCardType,
    ref
  ) => {
    const classes = useStyles();
    const {closeSnackbar} = useSnackbar();

    function handleDismiss() {
      closeSnackbar(id);
    }
    return (
      <SnackbarContent ref={ref}>
        <div className={classes.root}>
          <NotificationCard type={type}
            isToast
            id={toastId}
            text={text}
            read={read}
            subText={subText}
            timeStamp={timeStamp}
            notification={notification}
            isUrgent={isUrgent}
            viewEventCta={<ViewEventCta notification={notification} />}
            onCloseClick={handleDismiss}
            onDoubleClick={onDoubleClick}
            onMoreClick={onMoreClick}
            onLessClick={onLessClick}
            onReviewClick={onReviewClick}
            moreInfoLoading={moreInfoLoading}
            showMoreInfo={showMoreInfo} />
        </div>
      </SnackbarContent>
    );
  }
);

export default NotificationAlert;
